// @mui
import React from 'react';
import CustomTextField from '../Form/CustomTextField';
import AppDialog from './AppDialog';
import ImportantNotice from './ImportantNotice';
// utils

// ----------------------------------------------------------------------

export default function DeleteModal(props) {
    const [inputValue, setInputValue] = React.useState("");
    return (
        <>
            <AppDialog
                open={props.open}
                close={() => props.close()}
                title={props?.title}
                positiveTitle={props.positiveTitle ?? `Delete`}
                positivePress={() => props.submit()}
                positiveButtonStyle={props.positiveButtonStyle || { backgroundColor: '#D7114D', color: "white", border: "none", borderRadius: "20px", width: "auto" }}
                negativePress={() => props.close()}
                negativeTitle={'Cancel'}
                width={props.width || '50%'}
                negativeButtonStyle={props.negativeButtonStyle || { color: "#808588", backgroundColor: "#F9F9F9", border: "0px solid black", width: "auto", borderRadius: "20px" }}
                isMobile={props.isMobile}
                mobileSizeModalMaxHeight={props.mobileSizeModalMaxHeight}
                disabled={props?.verification && inputValue !== 'DELETE'}
            >
                <div className="pb-0">
                    {
                        props?.message && props.message
                    }
                    {
                        props?.verification &&
                        <div className='mt-3'>
                            <CustomTextField
                                title={props.inputTitle || "Please type DELETE to confirm."}
                                values={inputValue}
                                onChange={(e) => setInputValue(e)}
                            />
                        </div>
                    }
                </div>
            </AppDialog>
        </>


    );
}
